module.exports = __webpack_public_path__ + "media/audio23.babdc984.mp3";